import {
  IonButton,
  IonCard,
  IonCardContent,
  IonCardHeader,
  IonCardSubtitle,
  IonCardTitle,
  IonCol,
  IonContent,
  IonGrid,
  IonInput,
  IonNote,
  IonRow,
} from "@ionic/react";
import { useState } from "react";

const SignUp: React.FC = () => {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");

  const gotoLoginPage = () => {};

  const registerUser = () => {};

  return (
    <IonContent fullscreen>
      <IonGrid>
        <IonRow className="customCenter">
          <IonCol sizeXs="1" sizeMd="3"></IonCol>
          <IonCol sizeXs="10" sizeMd="6">
            <IonCard>
              <IonCardHeader>
                <IonCardTitle>
                  Welcome to <b>ARMOR</b>
                </IonCardTitle>
                <IonCardSubtitle>
                  The Battery Lifecycle Management Platform
                </IonCardSubtitle>
              </IonCardHeader>

              <IonCardContent>
                <IonRow className="h-100 d-flex ion-justify-content-center ion-align-items-center">
                  <IonInput
                    placeholder="Email@company.com"
                    type="email"
                    onIonChange={(e: any) => setEmail(e.target.value)}
                  />
                </IonRow>
                <IonRow className="justify-content-center align-items-center">
                  <IonInput
                    placeholder="Password"
                    type="password"
                    onIonChange={(e: any) => setPassword(e.target.value)}
                  />
                </IonRow>
                <IonRow className="justify-content-center align-items-center">
                  <IonInput
                    placeholder="Confirm Password"
                    type="password"
                    onIonChange={(e: any) => setPassword(e.target.value)}
                  />
                </IonRow>
                <IonRow className="justify-content-center align-items-center">
                  <IonInput
                    placeholder="Confirm Password"
                    type="password"
                    onIonChange={(e: any) => setPassword(e.target.value)}
                  />
                </IonRow>
                <IonButton fill="outline" onClick={registerUser}>
                  Register
                </IonButton>
                <br />
                <IonNote className="ion-padding-top">
                  Back to
                  <a onClick={gotoLoginPage}>Login</a>
                </IonNote>
              </IonCardContent>
            </IonCard>
          </IonCol>
          <IonCol sizeXs="1" sizeMd="3"></IonCol>
        </IonRow>
      </IonGrid>
    </IonContent>
  );
};

export default SignUp;
